import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
    HEXAGON_LOGO_MARK_PATHS,
    HEXAGON_LOGO_MARK_VIEWBOX_HEIGHT,
    HEXAGON_LOGO_MARK_VIEWBOX_WIDTH,
} from '../../utils/hexagon-logo-mark';

// 'sm' matches the navbar's existing rendered size (previously an inline
// style="width: 40px; height: 35.3px" on the raw <svg>) — Phase 1 is a like-for-like swap
// plus the color flatten, not a resize. The design doc's tighter 26-28px navbar sizing is a
// Phase 2 layout decision, to be revisited together with the surrounding spacing restyle.
const SIZE_PX: Record<'sm' | 'lg', number> = {
    sm: 40,
    lg: 56,
};

@Component({
    selector: 'app-hexagon-logo',
    templateUrl: './hexagon-logo.component.html',
    styleUrls: ['./hexagon-logo.component.scss'],
})
export class HexagonLogoComponent {

    @Input() size: 'sm' | 'lg' | number = 'sm';

    @Input() ariaLabel = 'Hexagon';

    paths: SafeHtml;

    constructor(sanitizer: DomSanitizer) {
        this.paths = sanitizer.bypassSecurityTrustHtml(HEXAGON_LOGO_MARK_PATHS);
    }

    get widthPx(): number {
        return typeof this.size === 'number' ? this.size : SIZE_PX[this.size];
    }

    get heightPx(): number {
        return this.widthPx * HEXAGON_LOGO_MARK_VIEWBOX_HEIGHT / HEXAGON_LOGO_MARK_VIEWBOX_WIDTH;
    }

}
